let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("54HVR")).then(() => parcelRequire('96u8o'));